import React, { useState } from 'react';
import { Button, ButtonVariants, TextGroup, IconButton, Datetime } from '../index';
import { Col } from 'react-bootstrap';
import moment from 'moment';
import 'react-datetime/css/react-datetime.css';

interface CustomDateProps {
    shipdate: Date;
    handleSubmit: (date: string) => void;
}

const momentLocal = (utc: Date) => moment(moment.utc(utc)).local();

function CustomDate({ shipdate, ...props }: CustomDateProps) {
    const [customDate, setCustomDate] = useState('');
    const [editing, setEditing] = useState(false);

    const handleDateEdit = () => {
        setEditing(true);
        let local = momentLocal(shipdate).toString();
        setCustomDate(local);
    };

    const isValidDate = () => {
        let selected = moment(customDate);
        if (customDate.length < 18 || !selected.isValid()) {
            return false;
        }
        let today = new Date();
        if (selected.valueOf() > today.getTime()) {
            return selected.valueOf() !== momentLocal(shipdate).valueOf();
        }
        return false;
    };

    return !editing ? (
        <TextGroup
            label="Delivery Date"
            value={
                <span>
                    {momentLocal(shipdate).format('MM/DD/YYYY | h:mm a')}
                    {momentLocal(shipdate).valueOf() > Date.now() && (
                        <IconButton
                            alt="edit icon"
                            name="EditIcon"
                            className="edit-icon"
                            size={window.innerWidth >= 1920 ? 50 : 40}
                            onClick={handleDateEdit}
                            buttonProps={{
                                'aria-label': 'Edit date',
                            }}
                        />
                    )}
                </span>
            }
        />
    ) : (
        <Col className="d-flex">
            <Datetime
                className="date-picker"
                initialValue={momentLocal(shipdate)}
                onChange={(date) => {
                    console.log('date time', date);
                    setCustomDate(date.toString() || '');
                }}
                timeFormat="h:mm A"
                timeConstraints={{
                    minutes: { min: 0, max: 59, step: 15 },
                }}
                isValidDate={(current) => {
                    let today = new Date();
                    today.setHours(0, 0, 0, 0);
                    return current.valueOf() >= today.getTime();
                }}
            />
            <Button
                variant={ButtonVariants.TERTIARY}
                className="button3"
                onClick={() => {
                    props.handleSubmit(customDate);
                    setEditing(false);
                }}
                disabled={!isValidDate()}
            >
                Save
            </Button>
            &nbsp;&nbsp;&nbsp;
            <Button
                variant={ButtonVariants.TERTIARY}
                className="button3"
                onClick={() => setEditing(false)}
            >
                Cancel
            </Button>
        </Col>
    );
}

export default CustomDate;
